import useSWR from 'swr';
import { createRestApiClient } from '..';
const restApiClient = createRestApiClient();
export const articleDetailFetcher = (type, id, comment) => {
  let apiUrl = ``;
  if (type == 'post') {
    apiUrl = `api/getFeedDetails?content_type=${type}&id=${id}&similar=${comment}`;
  } else {
    apiUrl = `api/getFeedDetails?content_type=${type}&id=${id}&comments=${comment}`;
  }
  return restApiClient
    .request({
      method: 'GET',
      url: apiUrl,
    })
    .then((res) => res.data);
};
export const getLatestContentUrl = (type, id) => {
  let apiUrl = `/api/getWebUrl`;
  const params = {
    filter: type,
    object_id: id,
  };
  return restApiClient
    .request({
      method: 'GET',
      url: apiUrl,
      params,
    })
    .then((res) => res.data);
};

export function useGetArticleDetail(initialData, type, id, comment) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: true,
  };
  const { data, error } = useSWR(
    `api/getFeedDetails/${id}`,
    () => articleDetailFetcher(type, id, comment),
    options,
  );
  return {
    articleDetailData: data,
    articleDetailLoading: !error && !data,
    articleDetailError: error,
  };
}
export const sendWhatsappLink = async (params) => {
  const url = `/api/sendWhatsappLink/?number=${params?.whatsappNo}&link=${params?.branchUrl}`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => {
      return res.data;
    });
  return data;
};

export const getRecentlyAddedArticles = (params, language) => {
  const url = `/new/content/getRecentlyAddedArticles`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params,
      headers: {
        'Accept-Language': language || 'en',
      },
    })
    .then((res) => res.data);
};
